<div class="stats" [@statsAnimation]="isExpanded ? 'expanded' : 'minimized'" *ngIf="detailedAgentStatIndicators && detailedAgentStatIndicators.length">
  <div class="stats-compact">
    <div *ngIf='isHybrid | async' class='info-wrapper'>
      <ng2-tooltip direction="top" [text]="'agentStats.metricsNotIncludeCX' | translate" [hideArrow]="true" [align]="'right'"></ng2-tooltip>
      <gux-icon [attr.screenreader-text]="'agentStats.metricsNotIncludeCX' | translate" icon-name="alert-info"></gux-icon>
    </div>
    <div class="indicators">
      <ng-container *ngFor="let agentStat of compactAgentStatIndicators;let i = index">
        <app-compact-agent-stat [indicator]="agentStat" id="{{ 'circular-' + i }}"></app-compact-agent-stat>
      </ng-container>
    </div>
    <div class="button-wrapper" (click)="toggleDetailedStats()">
      <svg-icon icon="{{ !isExpanded ? 'arrow-up' : 'arrow-down' }}" class="toggle-icon"></svg-icon>
    </div>
  </div>

  <div class="stats-detailed" [@statsDetailedAnimation]="isExpanded ? 'expanded' : 'minimized'" (@statsDetailedAnimation.start)="animationStart($event)" (@statsDetailedAnimation.done)="animationEnd($event)">
    <div class="detailed-title">
      <svg-icon icon="stats" class="stats-icon"></svg-icon>
      <div>{{ 'agentStats.yourDailyStatistics' | translate }}</div>
    </div>
    <div class="stat-list" [ngClass]="{ 'expanded': (shouldUseMaxHeight || isExpanded) }">
      <div *ngFor="let stat of detailedAgentStatIndicators;let i = index">
        <app-detailed-agent-stat [indicator]="stat" id="{{ 'detailed-item-' + i }}"></app-detailed-agent-stat>
      </div>
    </div>
  </div>
</div>
